import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>
                    Het belang van Vitamine D, en speciaal Vitamine D3
                </title>
                <link rel="canonical" href={route("blogs.fifty-five")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Hallo daar! Ik wil vandaag een belangrijk onderwerp met je bespreken - Vitamine D, en speciaal Vitamine D3. Misschien heb je er al wel eens van gehoord, maar weet je ook waarom het zo belangrijk is voor je lichaam? En wist je dat je in de winter extra Vitamine D3 nodig hebt? Laten we daar eens dieper op in gaan."
                />
                <meta
                    property="og:description"
                    content="Hallo daar! Ik wil vandaag een belangrijk onderwerp met je bespreken - Vitamine D, en speciaal Vitamine D3. Misschien heb je er al wel eens van gehoord, maar weet je ook waarom het zo belangrijk is voor je lichaam? En wist je dat je in de winter extra Vitamine D3 nodig hebt? Laten we daar eens dieper op in gaan."
                />
                <meta property="og:url" content={route("blogs.fifty-five")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Het belang van Vitamine D, en speciaal Vitamine D3 - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/vitamine-d.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/vitamine-d.webp"
                                    type="image/webp"
                                    alt="Vitamine D"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/vitamine-d.jpg"
                                    type="image/jpeg"
                                    alt="Vitamine D"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/vitamine-d.jpg"
                                    alt="Vitamine D"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Het belang van Vitamine D, en speciaal Vitamine D3
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Hallo daar! Ik wil vandaag een belangrijk onderwerp met
                        je bespreken - Vitamine D, en speciaal Vitamine D3.
                        Misschien heb je er al wel eens van gehoord, maar weet
                        je ook waarom het zo belangrijk is voor je lichaam? En
                        wist je dat je in de winter extra Vitamine D3 nodig
                        hebt? Laten we daar eens dieper op in gaan.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Waarom is Vitamine D belangrijk?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Vitamine D is essentieel voor ons lichaam. Het speelt
                        een cruciale rol in het onderhouden van onze botten en
                        tanden, en het ondersteunt ook ons immuunsysteem. Zonder
                        voldoende Vitamine D kunnen we ons moe en lusteloos
                        voelen, en kan ons lichaam moeite hebben om calcium op
                        te nemen, wat kan leiden tot zwakkere botten (Holick,
                        2007).
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Waarom extra Vitamine D3 in de winter?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Je vraagt je misschien af waarom we in de winter extra
                        Vitamine D3 nodig hebben. Nou, dat komt omdat de meeste
                        van onze Vitamine D wordt aangemaakt door blootstelling
                        aan zonlicht. En zoals je weet, is er in de winter
                        minder zonlicht beschikbaar. Bovendien zijn we tijdens
                        de koudere maanden meer geneigd om binnen te blijven,
                        waardoor we nog minder zonlicht krijgen (Webb, Kline &
                        Holick, 1988).
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Waar haal je Vitamine D3 vandaan?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Er zijn verschillende manieren om Vitamine D3 te
                        krijgen. Zoals ik al zei, is de belangrijkste bron
                        zonlicht. Maar er zijn ook bepaalde voedingsmiddelen die
                        Vitamine D3 bevatten, zoals vette vissoorten (zoals zalm
                        en makreel), lever, eieren en verrijkte voedingsmiddelen
                        zoals margarine en ontbijtgranen (Holick, 2007).
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe krijg je meer Vitamine D3?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Er zijn een paar dingen die je kunt doen om meer
                        Vitamine D3 te krijgen. Ten eerste, probeer elke dag wat
                        tijd buiten door te brengen, zelfs als het koud is.
                        Zelfs een korte wandeling tijdens je lunchpauze kan al
                        helpen. Ten tweede, zorg ervoor dat je voedingsmiddelen
                        eet die rijk zijn aan Vitamine D3. En ten slotte, als je
                        merkt dat je nog steeds niet genoeg Vitamine D krijgt,
                        kun je overwegen om een supplement te nemen. Maar
                        overleg dit altijd eerst met je arts (Holick, 2007).
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Ik hoop dat dit je wat meer inzicht heeft gegeven in het
                        belang van Vitamine D en Vitamine D3. Vergeet niet, je
                        gezondheid is belangrijk, dus zorg goed voor jezelf!
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl">
                        Referenties
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        De informatie in dit artikel is gebaseerd op betrouwbare
                        bronnen uit de literatuur.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Holick, M. F. (2007). Vitamin D deficiency. The New
                        England journal of medicine, 357(3), 266-281.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Webb, A. R., Kline, L., & Holick, M. F. (1988).
                        Influence of season and latitude on the cutaneous
                        synthesis of vitamin D3: exposure to winter sunlight in
                        Boston and Edmonton will not promote vitamin D3
                        synthesis in human skin. Journal of Clinical
                        Endocrinology & Metabolism, 67(2), 373-378.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
